import { render, staticRenderFns } from "./MultiReference.vue?vue&type=template&id=2fbe8a5f&"
import script from "./MultiReference.vue?vue&type=script&lang=js&"
export * from "./MultiReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports